import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'prlw-light-mode-overlay',
  templateUrl: './light-mode-overlay.component.html',
  styleUrls: ['./light-mode-overlay.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LightModeOverlayComponent {
  @Input() public isOpenFromModifiers: boolean = false;
  @Output() public readonly closeOverlay = new EventEmitter<boolean>();
  constructor(private readonly router: Router) {}

  public goToBuyLicense(): void {
    this.router.navigate(['/buy-license']);
    this.close();
  }

  public close(): void {
    this.closeOverlay.emit(true);
  }
}
